import React, { useState } from "react";
import "./Navbar.css";

const Navbar = ({ setSelectedPage, selectedPage }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleNavigation = (page) => {
        setSelectedPage(page);
        setIsMenuOpen(false); // Close menu on click (for mobile)
    };

    return (
        <header className="navbar">
            {/* Logo */}
            <div className="logo">
                <h1>Amar Clicks</h1>
            </div>

            {/* Hamburger Menu Button */}
            <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                <div className={isMenuOpen ? "line open" : "line"}></div>
                <div className={isMenuOpen ? "line open" : "line"}></div>
                <div className={isMenuOpen ? "line open" : "line"}></div>
            </div>

            {/* Navigation Menu */}
            <nav>
                <ul className={isMenuOpen ? "active" : ""}>
                    {["Home", "Portfolio", "Services", "Contact"].map((page) => (
                        <li
                            key={page}
                            className={selectedPage === page ? "active" : ""}
                            onClick={() => handleNavigation(page)}
                        >
                            {page}
                        </li>
                    ))}
                </ul>
            </nav>
        </header>
    );
};

export default Navbar;
